import _extends from "/usr/app/node_modules/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["className"],
  _excluded2 = ["className", "sideOffset"],
  _excluded3 = ["className", "icon", "children"];
var __jsx = React.createElement;
import * as React from "react";
import * as DropdownMenuPrimitive from "@radix-ui/react-dropdown-menu";
import { twMerge } from "tailwind-merge";
import { Icon } from "@syarahtech/ui";

// Root component
var DropdownMenu = DropdownMenuPrimitive.Root;

// Trigger component
var DropdownMenuTrigger = DropdownMenuPrimitive.Trigger;

// Portal for rendering outside DOM hierarchy
var DropdownMenuPortal = DropdownMenuPrimitive.Portal;

// Group for logical grouping
var DropdownMenuGroup = DropdownMenuPrimitive.Group;

// Separator component
var DropdownMenuSeparator = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(DropdownMenuPrimitive.Separator, _extends({
    ref: ref,
    className: twMerge("h-px bg-[#D6DFE9] my-2", className)
  }, props));
});
DropdownMenuSeparator.displayName = DropdownMenuPrimitive.Separator.displayName;

// Content component with styling
var DropdownMenuContent = /*#__PURE__*/React.forwardRef(function (_ref2, ref) {
  var className = _ref2.className,
    _ref2$sideOffset = _ref2.sideOffset,
    sideOffset = _ref2$sideOffset === void 0 ? 4 : _ref2$sideOffset,
    props = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/React.createElement(DropdownMenuPrimitive.Portal, null, /*#__PURE__*/React.createElement(DropdownMenuPrimitive.Content, _extends({
    ref: ref,
    sideOffset: sideOffset,
    className: twMerge(
    // Base styles
    "z-50 min-w-[200px] overflow-hidden rounded-lg", "bg-white p-2 shadow-lg border border-[#D6DFE9]",
    // Animation styles
    "data-[state=open]:animate-in data-[state=closed]:animate-out", "data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0", "data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95", className)
  }, props)));
});
DropdownMenuContent.displayName = DropdownMenuPrimitive.Content.displayName;

// Item component with icon support

var DropdownMenuItem = /*#__PURE__*/React.forwardRef(function (_ref3, ref) {
  var className = _ref3.className,
    icon = _ref3.icon,
    children = _ref3.children,
    props = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/React.createElement(DropdownMenuPrimitive.Item, _extends({
    ref: ref,
    className: twMerge(
    // Base styles matching MenuActionsModal
    "relative flex cursor-pointer select-none items-center gap-3", "rounded-lg px-4 py-3 mb-2 last:mb-0", "border border-[#D6DFE9] shadow-xs", "text-base font-medium transition-colors",
    // Interactive styles
    "hover:bg-gray-200 focus:bg-gray-200", "focus:outline-none",
    // Disabled styles
    "data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
    // RTL support - reverse flex direction in RTL
    "rtl:flex-row-reverse", className)
  }, props), icon && /*#__PURE__*/React.createElement(Icon, {
    icon: icon,
    className: "text-[#020202]",
    width: 5,
    height: 5
  }), /*#__PURE__*/React.createElement("span", null, children));
});
DropdownMenuItem.displayName = DropdownMenuPrimitive.Item.displayName;
export { DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem, DropdownMenuGroup, DropdownMenuSeparator, DropdownMenuPortal };